import React, { useEffect, useState } from 'react'
import { Checkbox } from '../formComponents'
import './index.css'
import {
  extractError,
  extractErrorFromSap
} from '../../service/response.service'
import t from '../../service/translate.service'
import { Alert } from 'antd'
import { api } from '../../service/api.service'
import PrimaryTitle from '../PrimaryTitle'
import { MuiDatePicker } from './components/MuiDatePicker'
import LoadingPageOverlay from '../LoadingPageOverlay'
import dayjs from 'dayjs'

export const DobInfoModal = ({ user }) => {
  const maxDate = new Date()
  const minDate = new Date();
  minDate.setFullYear(maxDate.getFullYear() - 120);
  const [dontAskAgain, setDontAskAgain] = useState(false)
  const [descriptionModalIsOpen, setDescriptionModalIsOpen] = useState(false)
  const [error, setError] = useState('')
  const [contractsWithDob, setContractsWithDob] = useState([])
  const [allContractNumbers, setAllContractNumbers] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const contractsWithDob = []
    for (let i = 0; i < user?.contractsToProvideDob?.length; i++) {
      const contractToProvideDob = user?.contractsToProvideDob[i]
      contractsWithDob?.push({
        ...contractToProvideDob,
        dob: null
      })
    }
    setContractsWithDob(contractsWithDob)
  }, [user])

  useEffect(() => {
    const allContractNumbers = contractsWithDob?.flatMap((p) =>
      p.contracts.map((c) => c.contractNumber)
    )
    setAllContractNumbers(allContractNumbers)
  }, [contractsWithDob])

  const onDateChange = (e, partnerId) => {
    setLoading(true)
    const contractsWithDobModified = []
    for (let i = 0; i < contractsWithDob?.length; i++) {
      const contractWithDob = contractsWithDob[i]
      if (contractWithDob?.partnerId == partnerId) {
        let isDateGreater = false
        let isDateLess = false
        if (
          e?.$d &&
          !e?.$d['Invalid Date'] &&
          dayjs(e?.$d)?.isAfter(dayjs(maxDate))
        ) {
          isDateGreater = true
        }
        if (
          e?.$d &&
          !e?.$d['Invalid Date'] &&
          dayjs(e?.$d)?.isBefore(dayjs(minDate))
        ) {
          isDateLess = true
        }
        contractsWithDobModified?.push({
          ...contractWithDob,
          dob: e,
          error: !e?.$d
            ? ''
            : isDateGreater || isDateLess || e?.$d['Invalid Date'] || !dayjs(e?.$d).isValid()
              ? t.DOB_INVALID_DATE
              : ''
        })
      } else {
        contractsWithDobModified?.push(contractWithDob)
      }
    }
    setContractsWithDob(contractsWithDobModified)
    setLoading(false)
  }

  const onSubmit = async () => {
    setLoading(true)
    try {
      setError('')
      const contractsWithDobModified = []
      for (let i = 0; i < contractsWithDob?.length; i++) {
        const contractWithDob = contractsWithDob[i]
        let isDateGreater = false
        let isDateLess = false
        if (
          contractWithDob?.dob?.$d &&
          !contractWithDob?.dob?.$d['Invalid Date'] &&
          dayjs(contractWithDob?.dob?.$d)?.isAfter(dayjs(maxDate))
        ) {
          isDateGreater = true
        }

        if (
          contractWithDob?.dob?.$d &&
          !contractWithDob?.dob?.$d['Invalid Date'] &&
          dayjs(contractWithDob?.dob?.$d)?.isBefore(dayjs(minDate))
        ) {
          isDateLess = true
        }

        if (dayjs(contractWithDob?.dob).isValid() && !isDateGreater && !isDateLess) {
          await api
            .post(
              `/contract/${contractWithDob?.contracts[0]?.contractNumber}/partner/${contractWithDob.partnerId}/dob`,
              {
                dob: dayjs(contractWithDob?.dob).format('YYYY-MM-DD')
              }
            )
            .then(() => {
              console.log('update dob success')
            })
            .catch((err) => {
              contractsWithDobModified?.push(contractWithDob)
              setError(
                extractErrorFromSap(err) || t[extractError(err)] || t['ERROR']
              )
            })
        } else {
          contractsWithDobModified?.push(contractWithDob)
        }
      }
      if (contractsWithDobModified?.length === 0) {
        localStorage.setItem(`skipAlert`, 'true')
        user?.dobsToProvideHandler(user, {
          action: 'skip',
          dontAskAgain: false,
          allContractNumbers
        })
      }
      setContractsWithDob(contractsWithDobModified)
    } catch (err) {
      setError(extractErrorFromSap(err) || t[extractError(err)] || t['ERROR'])
    }
    setLoading(false)
  }

  return (
    <div
      className="dob-provide-info"
      role="dialog"
      aria-modal="true"
      aria-labelledby="date-of-birth-title"
      aria-describedby="date-of-birth-description"
    >
      {loading && <LoadingPageOverlay />}
      <button
        onClick={() => {
          user?.dobsToProvideHandler(user, {
            action: 'skip',
            dontAskAgain: false,
            allContractNumbers
          })
        }}
        type="button"
        className="close-preview"
        aria-label="Close date of birth form"
      >
        x
      </button>
      <PrimaryTitle title={'GCP'} aria-level="1" role="heading" />
      {error && (
        <Alert
          message={error}
          type="error"
          role="alert"
          aria-live="assertive"
          style={{ marginBottom: '44px', marginTop: '12px' }}
        />
      )}
      <div className="dob-provide-info-top">
        <button
          onMouseOver={() => setDescriptionModalIsOpen(true)}
          onMouseOut={() => setDescriptionModalIsOpen(false)}
          onClick={() => setDescriptionModalIsOpen(true)}
          className="dob-provide-question-icon"
          aria-label="More information about the date of birth requirement"
        >
          i
        </button>

        <p
          role="alert"
          aria-live="assertive"
        >
          {t.DOB_INTRO_1}
          {allContractNumbers?.map((cN, index) => (
            <span
              key={index}
              aria-live="polite"
            >{`${index > 0 ? ', ' : ' '}${cN}`}</span>
          ))}
          {t.DOB_INTRO_2}
        </p>

        {descriptionModalIsOpen && (
          <div
            className="dob-provide-description-modal"
            role="alert"
            aria-live="assertive"
            id="dob-description-modal-description"
          >
            <button
              onClick={() => setDescriptionModalIsOpen(false)}
              type="button"
              className="dob-provide-description-modal-close-btn"
              aria-label="Close more information about the date of birth modal"
            >
              x
            </button>
            <p id="dob-description-modal-title">{t.DOB_MORE_INFO}</p>
          </div>
        )}
      </div>

      <form className="dob-provide-form">
        {contractsWithDob?.map((item) => (
          <div key={item?.partnerId} className="dob-provide-form-item">
            <div className="dob-provide-form-item-text">
              <span>
                {`${item?.partnerName}: ${item?.contracts?.map((contract) => ` ${contract?.contractNumber}`)}`}
              </span>
            </div>

            <div className="dob-provide-form-item-input">
              <label
                htmlFor={`dob-picker-${item?.partnerId}`}
                className="sr-only"
              >
                Date of Birth for {item?.partnerName}
              </label>
              <MuiDatePicker
                id={`dob-picker-${item?.partnerId}`}
                format="DD.MM.YYYY"
                maxDate={maxDate}
                onChange={(e) => onDateChange(e, item?.partnerId)}
                value={item?.dob}
                error={item?.error}
                minDate={minDate}
                aria-labelledby={`dob-picker-${item?.partnerId}`}
              />
            </div>
          </div>
        ))}
      </form>

      <div className="dob-provide-buttons">
        <div className="dob-provide-skip-wrapper">
          <button
            id="dobSkipBtn"
            type="button"
            className="button primary"
            aria-label={t.DOB_SKIP}
            onClick={() => {
              user?.dobsToProvideHandler(user, {
                action: 'skip',
                dontAskAgain,
                allContractNumbers
              })
            }}
          >
            {t.DOB_SKIP}
          </button>
          <label htmlFor="dobDontAskAgainBtn" className='sr-only'>
            {t.DOB_DONT_SHOW_AGAIN}
          </label>
          <Checkbox
            id="dobDontAskAgainBtn"
            value={dontAskAgain}
            labelBeforeText={t.DOB_DONT_SHOW_AGAIN}
            onChange={() => setDontAskAgain(!dontAskAgain)}
            aria-describedby="dobDontAskAgainBtn-desc"
            aria-label={t.DOB_DONT_SHOW_AGAIN}
          />
        </div>

        <button
          id="dobAddDob"
          type="button"
          disabled={
            contractsWithDob?.find(
              (cD) => dayjs(cD?.dob).isValid() && !cD?.error
            )
              ? false
              : true
          }
          className="button primary"
          onClick={onSubmit}
          aria-label={t.DOB_ADD_DATE_OF_BIRTH}
        >
          {t.DOB_ADD_DATE_OF_BIRTH}
        </button>
      </div>
    </div>
  )
}
